import React from 'react';
import classNames from 'classnames';
import { getIsMobile, getIsRtl } from '../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../context/api-context/use-api';
import { IS_LOCKED, ROOT } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { st, classes } from '../../styles/global-styles.st.css';
import styles from './app-wrapper.scss';
import cssVars from '../../styles/css-vars.scss';
export const AppWrapper = ({ children }) => {
    const [clientsideRendered, setCliensideRendered] = React.useState(false);
    const { resourceId, hideAvatars, isLocked } = useConfiguration();
    useOnClientSideRenderEffect(() => {
        setCliensideRendered(true);
    });
    const { isRtl, isMobile, showContainerBorderDev, ssrLoadedCorrectly } = useApi((state, _a, _h, ctx) => ({
        isRtl: getIsRtl(state),
        isMobile: getIsMobile(state),
        showContainerBorderDev: ctx.wcDevToolsState.showContainerBorder,
        ssrLoadedCorrectly: !!ctx.wcSsrLoadedCorrectly && !!ctx.wcSsrLoadedCorrectly[resourceId],
    }));
    const Wrapper = ssrLoadedCorrectly ? 'div' : 'section';
    const renderedIn = ssrLoadedCorrectly ? 'SSR_LOADED' : 'CSR_LOADED';
    return (React.createElement(Wrapper, { className: classNames(styles.root, cssVars.commentsContainer, 'wc-comments-root', {
            [styles.debugBorder]: showContainerBorderDev,
        }), dir: isRtl ? 'rtl' : 'ltr', "data-hook": classNames(ROOT, resourceId, {
            [IS_LOCKED]: isLocked,
            CLIENTSIDE_RENDERED: clientsideRendered,
        }), "data-render": renderedIn },
        React.createElement("div", { className: st(classes.root, { withoutAvatars: Boolean(hideAvatars) }, isMobile ? 'wc-app-mobile' : 'wc-app-desktop') }, children)));
};
const useOnClientSideRenderEffect = (callback) => {
    const [initialRender, setInitialRender] = React.useState(false);
    React.useEffect(() => {
        setInitialRender(true);
    }, []);
    React.useEffect(() => {
        if (initialRender) {
            callback();
        }
    }, [initialRender]);
};
//# sourceMappingURL=app-wrapper.js.map